import { batchUploadStore } from './batchUpload.store';

export const useBatchUploadStore = () => batchUploadStore;
